// extracted by mini-css-extract-plugin
export default {"header":"SuccessfulRegistrationPage_header__E5S8w","text":"SuccessfulRegistrationPage_text__4isYp"};